import apn from "@/assets/credentials/apn.webp.asset.json";
import aicpa from "@/assets/credentials/aicpa.webp.asset.json";
import ctrs from "@/assets/credentials/ctrs.webp.asset.json";
import astps from "@/assets/credentials/astps.png.asset.json";
import bbb from "@/assets/credentials/bbb.webp.asset.json";
import ctp from "@/assets/credentials/ctp.webp.asset.json";

interface CredentialsLogoBarProps {
  /** 'dark' for navy backgrounds, 'light' for white/secondary. */
  tone?: "dark" | "light";
  heading?: string;
  className?: string;
}

const logos = [
  {
    src: aicpa.url,
    alt: "AICPA — American Institute of CPAs member",
    label: "AICPA",
    // Wide horizontal lockup — height-capped tight, width allowed.
    heightClass: "h-7 lg:h-8",
  },
  {
    src: bbb.url,
    alt: "BBB Accredited Business",
    label: "BBB",
    heightClass: "h-9 lg:h-10",
  },
  {
    src: astps.url,
    alt: "ASTPS — American Society of Tax Problem Solvers Gold Member",
    label: "ASTPS Gold",
    heightClass: "h-9 lg:h-10",
  },
  {
    src: ctrs.url,
    alt: "Certified Tax Resolution Specialist (CTRS)",
    label: "CTRS",
    // Circular badge — render taller so optical weight matches the wordmarks.
    heightClass: "h-14 lg:h-16",
  },
  {
    src: ctp.url,
    alt: "Certified Tax Planner (CTP)",
    label: "CTP",
    heightClass: "h-14 lg:h-16",
  },
  {
    src: apn.url,
    alt: "Audit Protection Network member",
    label: "Audit Protection Network",
    heightClass: "h-14 lg:h-16",
  },
];

/**
 * Credential & affiliation logo strip. Renders the firm's professional
 * memberships and accreditations as a horizontal logo bar — boosts
 * trust signals above the fold without taking much vertical space.
 */
export const CredentialsLogoBar = ({
  tone = "light",
  heading = "Credentialed · Accredited · Trusted",
  className = "",
}: CredentialsLogoBarProps) => {
  const isDark = tone === "dark";
  return (
    <section
      aria-label="Professional credentials and affiliations"
      className={`py-8 lg:py-10 ${isDark ? "bg-navy/95 border-y border-white/10" : "bg-white border-y border-border"} ${className}`}
    >
      <div className="container mx-auto px-4">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] mb-6 text-gold">
          {heading}
        </p>
        <ul className="flex flex-wrap items-center justify-center gap-x-8 sm:gap-x-10 lg:gap-x-12 gap-y-6 max-w-5xl mx-auto">
          {logos.map((l) => (
            <li
              key={l.label}
              className="flex items-center justify-center h-16 lg:h-[72px]"
            >
              <img
                src={l.src}
                alt={l.alt}
                loading="lazy"
                className={`w-auto object-contain transition-opacity ${l.heightClass} ${
                  isDark ? "opacity-95 hover:opacity-100" : "opacity-90 hover:opacity-100"
                }`}
               width={160} height={80} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

